/**
 * Foundation/Anagrafica — validazioni di formato comuni a tutte le anagrafiche Suite.
 * Restituiscono un messaggio o `null`; validano solo ciò che è verificabile localmente.
 */

/** Codice fiscale azienda: 11 cifre (persona giuridica) oppure 16 alfanumerici (persona fisica). */
export function validateCodiceFiscale(value) {
  const v = (value || "").trim().toUpperCase();
  if (!v) return null; // opzionale
  if (/^\d{11}$/.test(v)) return null;
  if (/^[A-Z0-9]{16}$/.test(v)) return null;
  return "Codice fiscale non valido (11 cifre per aziende o 16 caratteri per persone fisiche)";
}

/** Partita IVA italiana: 11 cifre + check digit secondo l'algoritmo "Luhn italiano". */
export function validatePartitaIVA(value) {
  const v = (value || "").trim();
  if (!v) return null; // opzionale
  if (!/^\d{11}$/.test(v)) return "Partita IVA non valida (devono essere 11 cifre)";
  // Luhn italiano
  let sum = 0;
  for (let i = 0; i < 11; i++) {
    let d = parseInt(v[i], 10);
    if (i % 2 === 1) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
  }
  if (sum % 10 !== 0) return "Partita IVA non valida (controllo cifra di controllo fallito)";
  return null;
}

/** CAP italiano: esattamente 5 cifre numeriche. */
export function validateCAP(value) {
  const v = (value || "").trim();
  if (!v) return null; // opzionale
  if (!/^\d{5}$/.test(v)) return "CAP non valido (5 cifre numeriche)";
  return null;
}

/** Provincia: sigla di 2 lettere maiuscole fra elenco ufficiale italiano. */
export function validateProvincia(value, provinceSet) {
  const v = (value || "").trim().toUpperCase();
  if (!v) return null; // opzionale
  if (!/^[A-Z]{2}$/.test(v)) return "Sigla provincia non valida";
  if (provinceSet && !provinceSet.has(v)) return "Sigla provincia non riconosciuta";
  return null;
}

export const EMAIL_SYNTAX_ERROR = "L'indirizzo inserito non ha un formato e-mail valido.";

/** E-mail/PEC: solo correttezza sintattica (la natura PEC non è verificabile localmente). */
export function validateEmailSyntax(value) {
  const v = (value || "").trim();
  if (!v) return null;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? null : EMAIL_SYNTAX_ERROR;
}

/** Un codice fiscale numerico di 11 cifre può coincidere con la Partita IVA. */
export function isTaxCodeVatCompatible(taxCode) {
  return /^\d{11}$/.test((taxCode || "").trim());
}
